import { gsap, ScrollTrigger, ScrollSmoother } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);


const ScrollAnimation = {
	scrollAnimation: function() {
        // Check if the window width is greater than 1024px (desktop)
        if (window.innerWidth > 1024) {
            ScrollTrigger.normalizeScroll(true);

            let smoother = ScrollSmoother.create({
                smooth: 1.2,
                effects: true,
            });

            document.querySelectorAll('[data-speed]').forEach((element) => {
                const speed = element.getAttribute('data-speed');
            });

            // $('[data-lity]').on('click', function(e) {
            //     e.preventDefault();
            //     //$('body, html, #smooth-wrapper').addClass('overflow');
            //     smoother.kill();
            // });
            ScrollTrigger.normalizeScroll({ allowNestedScroll: true });

        }




    },
    init: function() {
        this.scrollAnimation();

    },
};

export default ScrollAnimation;
